// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_pnpm_crypto-js_4_2_0_node_modules_crypto-js_index_js-node_modules_pnpm_j-ab9ce4":"0fe5c3b2","src_app_js":"93ff91ae"}[chunkId] + ".js";
};